module.exports = __webpack_public_path__ + "img/list_D10E.be80e6e6.png";